import { map, merge, min, pick, pipe } from "ramda";
import uuid from "uuid/v4";

import { replaceInCollection } from "helpers/collections";
import type { SelectedTransportOptions } from "types/reducers/ordering_options";
import type { Fulfillment } from "types/reducers/store_info";

export function selectedOptionOfAvailable(
  selectedTransport: SelectedTransportOptions,
  fulfillmentTypes: Fulfillment[]
): SelectedTransportOptions | null {
  return (
    fulfillmentTypes.find(
      ({ name }) =>
        name.toLocaleLowerCase() === selectedTransport.toLocaleLowerCase()
    )?.name ?? null
  );
}

export function createCartItem(item) {
  return {
    ...item,
    cartId: uuid(),
    quantity: 1,
    instructions: "",
    selectedSides: [],
    selectedModifiers: map(
      pipe(
        group => {
          return {
            ...group,
            safeMin: min(group.modifiers.length, group.minimumRequired),
          };
        },
        pick(["id", "safeMin"]),
        merge({ mods: [] })
      ),
      item.modifierGroups
    ),
  };
}

export function addSelectedModInModGroupToItem(
  selectedModsGroup,
  cartItem,
  selectedMod
) {
  const updatedSelectedModsGroup = {
    ...selectedModsGroup,
    mods: [...selectedModsGroup.mods, selectedMod],
  };

  return {
    ...cartItem,
    selectedModifiers: replaceInCollection(
      selectedModsGroup,
      updatedSelectedModsGroup,
      cartItem.selectedModifiers
    ),
  };
}
